/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import { Card, Header, Main } from 'generics/Card'
import { COLORS } from 'constants/colors'
import { I18N } from 'constants/props'
import Icon from 'generics/Icon'
import Translation from 'generics/Translation'

import styles from './ModalPurchaseInviteInfo.scss'

const ModalPurchaseInviteInfo = ({ i18n, handleClose = () => {} }) => {
  return (
    <div
      className={styles.modal}
      onKeyDown={e => {
        if (e.key === 'Escape') {
          e.preventDefault()
          handleClose()
        }
      }}
      role="dialog"
    >
      <Card barBackgroundColor={COLORS.orangePumpkin.rgba} className={styles.card}>
        <Header className={styles.header}>
          <h1>{i18n.pageAdministration.modalPurchaseInvite.title}</h1>
        </Header>

        <Icon.Stroke7
          className={styles.close}
          name="close"
          onClick={handleClose}
          title={i18n.pageAdministration.modalPeople.close}
        />

        <Main className={styles.main}>
          <Container className={styles.licenseInfo}>
            <Row>
              <Col>
                <p className={styles.sectionTitle}>{i18n.pageAdministration.modalPurchaseInvite.typesOfLicenses}</p>

                <p className={styles.subSectionTitle}>{i18n.pageAdministration.modalPurchaseInvite.pro}</p>
                <ul className={styles.infoList}>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.proBenefits1}</li>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.proBenefits2}</li>
                </ul>

                <p className={styles.subSectionTitle}>{i18n.pageAdministration.modalPurchaseInvite.limited}</p>
                <ul className={styles.infoList}>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.limitedBenefits1}</li>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.limitedBenefits2}</li>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.limitedBenefits3}</li>
                </ul>

                <p className={styles.sectionTitle}>{i18n.pageAdministration.modalPurchaseInvite.sendingInvites}</p>
                <ul className={styles.infoList}>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.sendToAnyone}</li>
                  <li>
                    {i18n.pageAdministration.modalPurchaseInvite.sendProInstructions}
                    <p className={styles.noteText}>{i18n.pageAdministration.modalPurchaseInvite.noteOnProFirst}</p>
                  </li>
                </ul>

                <ul className={styles.infoList}>
                  <li>{i18n.pageAdministration.modalPurchaseInvite.sendLimitedFallback}</li>
                </ul>
              </Col>
            </Row>
          </Container>
        </Main>
      </Card>
    </div>
  )
}

ModalPurchaseInviteInfo.propTypes = {
  i18n: I18N.isRequired,
  handleClose: PropTypes.func,
}

ModalPurchaseInviteInfo.defaultProps = {
  handleClose: () => {},
}

export default Translation(ModalPurchaseInviteInfo, ['pageAdministration'])
